// CSS
import { fileDownload } from 'Admin/Component/AdFunc'
import '_Asset/css/User/Page/UiComponent/navigation.css'

const tabList = [
  {
    name: 'Basic Tabs',
    class: 'Class: [type_1 / type_1_bg]',
    otList: [
      {type: "type_1_bg", color: "sfrtBlue", round: "round_10", size: "sm", icoPos: "i_lt"},
      {type: "type_1_bg", color: "sfrtBlue", round: "round_100", size: "sm"},
      {type: "type_1", color: "sfrtBlue", round: "round_100", size: "sm"},
    ]
  },
  {
    name: 'Transparent tabs',
    class: 'Class: [type_2]',
    otList: [
      {type: "type_2", color: "sfrtBlue", round: "round_100", size: "sm"},
      {type: "type_2", color: "sfrtBlue", round: "round_100", size: "sm", icoPos: "i_lt"},
    ]
  },
  {
    name: 'Border tabs',
    class: 'Class: [type_2_bg]',
    otList: [
      {type: "type_2_bg", color: "sfrtBlue", round: "round_100", size: "sm"},
      {type: "type_2_bg", color: "sfrtBlue", round: "round_100", size: "sm", icoPos: "i_lt"}
    ]
  },
  {
    name: 'Line tabs',
    class: 'Class: [type_3]',
    otList: [
      {type: "type_3", color: "sfrtBlue", size: "sm"},
      {type: "type_3", color: "sfrtBlue", size: "sm", icoPos: "i_col"},
    ]
  },
  {
    name: 'Line-bg tabs',
    class: 'Class: [type_4]',
    otList: [
      {type: "type_4", color: "sfrtBlue", round: "round_10", size: "sm"},
      {type: "type_4", color: "sfrtBlue", round: "round_10", size: "sm", icoPos: "i_col"},
    ]
  },
]

const paginationArr = [
  {
    name: 'Pagination Type_1',
    class: 'Class: [pagination type_1]',
    paginationList: [
      { type: "type_1", size: 'sm', double: false },
      { type: "type_1", size: 'md', double: true },
    ]
  },
  {
    name: 'Pagination Type_2',
    class: 'Class: [pagination type_2]',
    paginationList: [
      { type: "type_2", size: 'lg', double: false },
      { type: "type_2", size: 'lg', double: true },
    ]
  }
]

// Tab Component 
const TabList = ({item}) => {
  return (
    <div className={`tabGroup ${item.type} ${item.color} ${item.round}`}>
      <div className="tabBar">
        <button type="button" className={`btn ${item.size} ${item.icoPos} active`}>{item.icoPos && <i className="icofont-ui-settings"></i>}settings</button>
        <button type="button" className={`btn ${item.size} ${item.icoPos}`}>{item.icoPos && <i className="icofont-page"></i>} Normal</button>
        <button type="button" className={`btn ${item.size} ${item.icoPos}`}>{item.icoPos && <i className="icofont-ui-music"></i>}Music</button>
        <button type="button" className={`btn ${item.size} ${item.icoPos}`}>{item.icoPos && <i className="icofont-ui-user"></i>}User</button>
      </div>
      <div className="tabCont">
        <p>테스트 텍스트입니다.</p>
        <p>테스트 텍스트입니다.</p>
        <p>테스트 텍스트입니다.</p>
      </div>
    </div>
  )
}

const Navigation = () => {

  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>Navigation <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>Components: <span>Tabs, Pagination</span></p>
      </div>

      <div className="useWay">
        <h2>How to use the Tab kit</h2>
        <p>Click navigation to copy and paste where you want to use it.</p>
        <p>Bagic Class: <span>tabGroup, tabBar / pagination</span></p>
        <p>Ex. class="<span>tabGroup type_1_bg sfrtBlue round_10</span>"</p>
      </div>

      {/* Tabs */}
      {tabList.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>탭을 눌러 태그를 복사 할 수 있습니다.</p>
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>
          
          <div className="contWrap">
            {key.otList.map((item, i) =>
              <TabList key={i} item={item} />
            )}
          </div>  
        </div>
      )}

      {/* Paginations */}
      {paginationArr.map((key, i) =>
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>페이지네이션을 눌러 태그를 복사 할 수 있습니다.</p>
          <div className="tit">
            <h2>{key.name}</h2>
            <p>{key.class}</p>
          </div>
          
          <div className="contWrap center">
            {key.paginationList.map((item, i) =>
              <div className={`pagination ${item.type} ${item.size}`} key={i}>
                {
                  item.double &&
                  <button type="button" className="first" disabled><i className="icofont-rounded-double-left"></i></button>
                }
                <button type="button" className="prev" disabled><i className="icofont-rounded-left"></i></button>
                
                <button type="button" className="active">1</button>
                <button type="button">2</button>
                <button type="button">3</button>
                <button type="button">...</button>
                <button type="button">40</button>
                
                <button type="button" className="next"><i className="icofont-rounded-right"></i></button>
                {
                  item.double &&
                  <button type="button" className="last"><i className="icofont-rounded-double-right"></i></button>
                }
              </div>
            )}
          </div>  
        </div>
      )}
    </div>
  )
}

export default Navigation